module.exports = __webpack_public_path__ + "img/10.63de3b64.png";